export const INITIAL_SCHEMA = {
  title: '', // Título da página! ==> (Required)
  breadcrumbs: false,
  background: {
    desktopImage: '', // Background image desktop!
    desktopColor: '#FFFFFF', // Background color desktop!
    mobileImage: '', // Background image mobile!
    mobileColor: '#FFFFFF' // Background color mobile!
  }
};

export const INITIAL_CONFIG = {
  config: {
    dark: false,
    menu: false,
    sidebar: false,
    container: {
      fluid: true,
      gridListMd: false
    }
  },
  paths: {},
  theme: {
    accent: '#e5e5e5',
    error: '#ff5252',
    info: '#2196f3',
    primary: '#e5e5e5',
    secondary: '#e5e5e5',
    success: '#4caf50',
    warning: '#fb8c00'
  },
  header: {
    logo: {
      alt: '',
      class: '',
      src: '',
      height: 42,
      width: ''
    },
    attributes: {
      absolute: false,
      app: true,
      bottom: false,
      clippedLeft: false,
      clippedRight: false,
      collapse: false,
      color: '#C21818',
      dark: false,
      dense: false,
      elevation: 0,
      extensionHeight: 36,
      flat: false,
      floating: false,
      height: '',
      light: false,
      maxHeight: '',
      maxWidth: '',
      minHeight: '',
      minWidth: '',
      prominent: false,
      short: false,
      src: '',
      tag: 'header',
      tile: true,
      width: ''
    }
  },
  menu: {
    attributes: {
      absolute: false,
      bottom: false,
      collapse: false,
      color: '#C21818',
      dark: false,
      dense: false,
      elevation: 0,
      extended: false,
      extensionHeight: 48,
      flat: false,
      floating: false,
      height: 36,
      light: false,
      maxHeight: 36,
      maxWidth: '100%',
      minHeight: 36,
      minWidth: '100%',
      width: '100%',
      prominent: false,
      short: false,
      src: '',
      tag: 'header',
      tile: true
    }
  },
  breadcrumbs: {
    divider: '',
    accessibility: false
  },
  sidebar: {
    src: '',
    color: '#e5e5e5',
    dark: false,
    light: false,
    width: 256
  },
  footer: {
    visible: false,
    page: '',
    mode: '',
    showPage: false,
    background: {
      image: '',
      color: '#e5e5e5'
    },
    atributes: {
      absolute: false,
      inset: false,
      class: ''
    }
  },
  progressbar: {
    color: '#e5e5e5',
    failedColor: '#e5e5e5',
    thickness: '',
    autoRevert: false,
    location: '',
    inverse: false
  },
  login: {
    componentName: 'i4pro-login',
    params: {
      backgroundImage: '',
      backgroundColor: '#e5e5e5',
      logo: {
        src: '',
        srcHeight: '',
        srcWidth: ''
      },
      title: {
        visible: true,
        value: "Portal titulo",
        style: "",
        class: ""
      },
      subtitle: {
        visible: true,
        value: "Portal subtitulo",
        style: "",
        class: ""
      },
      companyName: ''
    },
    recaptcha: {
      visible: false,
      sitekey: ''
    }
  },
  dialogs: {}
};

export const DEFAULT_MODES = {
  list: {
    attributes: {
      //--> Configurações para o layout da tela e modos list e card. ==> (Required)
      actionsToolbar: true, // Habilita os botões na toolbar da lista.
      attributesLayout: {
        dense: true
      }, //--> Propriedades css do flex-box para posicionar elementos na tela.
      attributesTable: {
        //--> Contém as configurações da table (list)
        keyValue: 'name',
        showSearch: true,
        editIcon: 'edit',
        editMode: '',
        dataTable: {
          dense: true,
          showSelect: false,
          multiSort: false,
          showExpand: false,
          expandAll: false,
          hideActions: false,
          hideDefaultFooter: false,
          externalPagination: true,
          sortBy: [''],
          loadingText: 'Carregando...',
          noDataText: 'Sem dados...',
          noResultsText: 'Sem resultados...',
          footerProps: {
            showFirstLastPage: true,
            firstIcon: 'fas fa-angle-double-left',
            lastIcon: 'fas fa-angle-double-right',
            prevIcon: 'keyboard_arrow_left',
            nextIcon: 'keyboard_arrow_right'
          }
        },
        itemsPerPageOptions: [
          {
            text: '6',
            value: 6
          },
          {
            text: '12',
            value: 12
          },
          {
            text: '32',
            value: 32
          },
          {
            text: 'Todos',
            value: -1
          }
        ]
      },
      attributesDataIterator: {
        //--> Contém as configurações da table (grid)
        keyValue: '',
        editMode: '',
        itemsPerPage: 4,
        itemsPerPageOptions: [
          {
            text: '4',
            value: 4
          },
          {
            text: '16',
            value: 16
          },
          {
            text: '32',
            value: 32
          },
          {
            text: 'Todos',
            value: -1
          }
        ],
        breakpoints: {
          xs: 12,
          sm: 6,
          md: 3,
          lg: 3,
          xl: 2
        },
        dataIteratorComponents: [
          {
            default: true,
            label: 'List',
            icon: 'receipt',
            component: {
              name: 'field-i4pro-card-list',
              attributes: {}
            }
          }
        ]
      }
    },
    executeInLoad: true, //--> Indica se a procedure vai ser executada assim que carregar a tela ==> (Required)
    display: 'list', //--> Define o modo que a lista irá renderizar inicialmente, por exemplo: list ou grid. ==> (Required)
    dialog: '', // --> Seleciona dialog padrão!
    targetList: 'page', //--> Define onde será renderizado o modo de edição da tela no modo lista, por exemplo: page, dialog, below e sidebar. ==> (Required)
    targetCard: 'page', //--> Define onde será renderizado o modo de edição da tela no modo grid, por exemplo: page, dialog, below e sidebar. ==> (Required)
    // child: {
    //   mode: 'search'
    // }, //--> Define qual o modo de tela que será aberto em conjunto com a tela lista. Vem desabilitado por padrão!
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos que aparecerá na lista quando for definido que a table é editável
    groups: [],
    headers: [
      {
        text: 'Dessert',
        value: 'name',
        align: 'left',
        sortable: false,
        width: 'auto',
        visible: true
      },
      {
        text: 'Calories',
        value: 'calories',
        align: 'center',
        sortable: true,
        width: 'auto',
        visible: true
      },
      {
        text: 'Carbs',
        value: 'carbs',
        align: 'center',
        sortable: true,
        width: 'auto',
        visible: true
      }
    ], //--> Define quais as colunas serão exibidas na lista e nos cards da tela. ==> (Required)
    items: [],
    actions: {}, //--> Contém as configurações dos botões de ações da tela ==> (Required)
    recordActions: {},
    recordActionsModel: [],
    conditions: [], //--> Contém uma lista de regras das condições ==> (Required)
    lookups: {} //--> Controle interno do sistema, precisa somente existir a propriedade.
  },

  form: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    // tabs: {}, //--> Contém as configurações das tabs da tela.
    // steps: {}, //--> Contém as configurações dos steps da tela.
    fields: [], //--> Lista de campos forms da tela.
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela.
    actions: {}, //--> Contém as configurações dos botões de ações da tela.
    conditions: [] //--> Contém uma lista de regras das condições.
  },

  new: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    // tabs: {}, //--> Contém as configurações das tabs da tela.
    // steps: {}, //--> Contém as configurações dos steps da tela.
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela. ==> (Required)
    actions: {}, //--> Contém as configurações dos botões de ações da tela. ==> (Required)
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  },

  search: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true
      } //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela.
    actions: {}, //--> Contém as configurações dos botões de ações da tela.
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  },

  sidebar: {
    attributes: {
      //--> Configurações para o layout da tela. ==> (Required)
      attributesLayout: {
        dense: true
      }, //--> Propriedades do flex css para posicionar elementos na tela. ==> (Required)
      attributesNavigationDrawer: {
        height: '100%',
        width: '40%'
      }
    },
    procedure: {
      name: ''
    }, //--> Especifica qual a procedure que será executada para carregar os dados da tela. ==> (Required)
    fields: [], //--> Lista de campos forms da tela. ==> (Required)
    groups: [], //--> Lista de grupos de coluna para agrupar os fields na tela. ==> (Required)
    actions: {}, //--> Contém as configurações dos botões de ações da tela. ==> (Required)
    conditions: [] //--> Contém uma lista de regras das condições. ==> (Required)
  }
};

export const removeActionsMaster = list => {
  list.forEach((item, index) => {
    if (item.label == 'Anterior' || item.label == 'Próximo') {
      list.splice(index, 1);
    }
  });
};

export const addActionsMaster = (list, page, mode) => {
  let actionsVisible = false;

  list.forEach((item, index) => {
    if (item.label == 'Anterior' || item.label == 'Próximo') {
      actionsVisible = true;
    }
  });

  if (!actionsVisible) {
    list.push({
      attributes: {
        color: 'primary'
      },
      attributesIcon: {
        icon: 'fas fa-arrow-circle-left'
      },
      label: 'Anterior',
      navigation: 'previous',
      page,
      mode,
      visible: true
    });

    list.push({
      attributes: {
        color: 'primary'
      },
      attributesIcon: {
        icon: 'fas fa-arrow-circle-right'
      },
      label: 'Próximo',
      navigation: 'next',
      page,
      mode,
      visible: true
    });
  }
};

export const randomString = () =>
  `i4pro${Math.random()
    .toString(36)
    .substring(2)}`;

export const addMandatoryParameters = schema => {
  const modes = ['list', 'form', 'new', 'search', 'sidebar'];

  if (!('title' in schema)) {
    schema.title = '';
  }

  if (!('breadcrumbs' in schema)) {
    schema.breadcrumbs = false;
  }

  if (!('background' in schema)) {
    schema.background = {
      desktopImage: '',
      desktopColor: '#FFFFFF',
      mobileImage: '',
      mobileColor: '#FFFFFF'
    };
  } else {
    schema.background.desktopColor === '' && (schema.background.desktopColor = '#FFFFFF');
    schema.background.mobileColor === '' && (schema.background.mobileColor = '#FFFFFF');
  }

  if ('list' in schema) {
    if (!schema.list.hasOwnProperty('recordActions')) {
      schema.list.recordActionsModel = [];
      schema.list.recordActions = {};
    }

    if (!schema.list.conditions) {
      schema.list.conditions = [];
    }

    if (!schema.list.inlineConditions) {
      schema.list.inlineConditions = [];
    }

    if ('actions' in schema.list && !'model' in schema.list.actions) {
      schema.list.actions.model = randomString();
    }
  }

  modes.forEach(mode => {
    if (mode in schema) {
      if ('groups' in schema[mode] && schema[mode].groups.length) {
        schema[mode].groups.forEach(group => {
          if (!('type' in group)) group.type = 'i4proColumnGroup';

          if (!('model' in group)) group.model = randomString();
        });
      }

      if ('tabs' in schema[mode]) {
        if (!('model' in schema[mode].tabs)) schema[mode].tabs.model = randomString();

        if (!('type' in schema[mode].tabs)) schema[mode].tabs.type = 'i4proTabs';
      }

      if (mode !== 'list' && 'master' in schema[mode] && Object.keys(schema[mode].master).length !== 0) {
        if (!('model' in schema[mode].master)) schema[mode].master.model = randomString();
      }

      if ('actions' in schema[mode] && Object.keys(schema[mode].actions).length !== 0) {
        if (!('model' in schema[mode].actions)) schema[mode].actions.model = randomString();

        if (!('type' in schema[mode].actions)) {
          let type = schema[mode].actions.component === 'i4pro-button' ? 'i4proButton' : '';

          schema[mode].actions.type = type;
        }
      }
    }
  });

  return schema;
};
